"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateUID = exports.isSegmentOptions = exports.isString = exports.isFunction = exports.isObject = void 0;
const isObject = (value) => {
    return Boolean(value) && !Array.isArray(value) && typeof value === 'object';
};
exports.isObject = isObject;
const isFunction = (value) => {
    return Boolean(value) && typeof value === 'function';
};
exports.isFunction = isFunction;
const isString = (value) => {
    return typeof value === 'string';
};
exports.isString = isString;
const checkForSegmentOptions = (value) => {
    const options = value;
    return (options &&
        (options.anonymousId !== undefined || options.context !== undefined || options.integrations !== undefined));
};
const isSegmentOptions = (value) => {
    return Boolean(checkForSegmentOptions(value));
};
exports.isSegmentOptions = isSegmentOptions;
const generateUID = () => {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
};
exports.generateUID = generateUID;
//# sourceMappingURL=helper.js.map